<template>
    <image-slide

        :img="event.cover ? event.cover.cached_url : null"
        :item="event"
    />
<!--    <div v-if="image" class="img__holder" :style="[!isSingle ? { marginTop : event.padding + 'px' } : '' ]" v-touch:tap="go">
        <img :src="image ? image.large : ''" :class="className" :alt="image.description ? image.description : ''"/>
        <div class="img__caption">
            <div class="img__inner" v-if="isMobile || isTablet">
                <div class="img__title img__title-full">
                    <div class="type" v-if="event.type">{{ event.type }}</div>&nbsp;
                    {{ event.name}}<span v-if="image.credits"> - &copy; {{ image.credits}}</span>
                </div>
            </div>
            <div class="img__inner " v-else>
                <div class="img__title"><div class="type type-no-margin" v-if="event.type">{{ event.type }}</div>&nbsp;{{ event.name}}</div>
                <div class="img__credit" v-if="image.credits">&copy; {{ image.credits}}</div>
            </div>
        </div>
    </div>-->

</template>

<script>
    import ScreenSize from "../../../mixins/screen-size";
    import ImageSlide from "./ImageSlide";
    import {mapGetters} from "vuex";

    export default {
        name: "EventSlide",
        mixins: [ScreenSize],
        components: {
            ImageSlide
        },
        props: {
            event: null,
            image: null,
            isSingle: false
        },
        data: () => {
            return {
                className: 'img__project',
                show: false,
                interval: null,
                mobile: false,
                tablet: false
            }
        },
        computed: {
            ...mapGetters('event', {
                thumbnail: 'getEventThumbnail'
            })

        },
        methods: {



        }
    }
</script>

